var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 0C23.2843 0 30 6.71567 30 14.9999C30 19.1416 28.3207 22.893 25.607 25.607C22.893 28.3209 19.142 30 14.9999 30C6.71567 30 0 23.2843 0 15.0001C0 6.71588 6.71567 0.000214284 14.9999 0.000214284L15.0001 0ZM15.0001 1.81847C7.7198 1.81847 1.81895 7.71985 1.81895 14.9996C1.81895 22.2794 7.72034 28.1808 15.0001 28.1808C22.2799 28.1808 28.1813 22.2794 28.1813 14.9996C28.1813 7.71985 22.2799 1.81847 15.0001 1.81847Z",
    fill: "#42A460"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72336 9.721C10.4637 7.56685 12.6384 6.24097 14.8664 6.24097C17.6868 6.24097 20.2787 8.35826 20.2787 11.2815C20.2787 13.2766 19.0382 14.9837 17.2517 15.8036C16.3768 16.2025 15.8645 17.0121 15.8645 17.972V19.0399H13.8687V17.972C13.8687 16.2295 14.8416 14.7209 16.4257 13.9954C17.4977 13.5043 18.2829 12.4873 18.2829 11.2815C18.2829 9.45218 16.5942 8.23676 14.8667 8.23676C13.415 8.23676 12.1276 9.00705 11.5972 10.3848L9.72363 9.72105L9.72336 9.721Z",
    fill: "#42A460"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8662 20.7052C15.7093 20.7052 16.3934 21.3893 16.3934 22.2315C16.3934 23.0746 15.7093 23.7587 14.8662 23.7587C14.0239 23.7587 13.339 23.0746 13.339 22.2315C13.339 21.3892 14.0237 20.7052 14.8662 20.7052Z",
    fill: "#42A460"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.80347ee1f4658a3acc269b8df56615ac.svg";
export { ForwardRef as ReactComponent };